module.exports = __webpack_public_path__ + "img/5.e847c9a.png";